export default "__VITE_ASSET__DMl1y9La__"